import React from 'react';
import PropTypes from 'prop-types';
import PriceLabel from '@prisjakt/ui-price-label';
import ShippingLabel from '@prisjakt/ui-shipping-label';
import InternationalPriceLabel from '@prisjakt/ui-international-price-label';
import shallowEqual from 'shallowequal';

import * as S from './styles';

const PriceColumn = React.memo(
  ({
    price,
    storeIsFeatured,
    isInternationalPrice,
    campaignStyling,
    align,
  }) => (
    <S.PriceColumn align={align}>
      <PriceLabel
        value={price.exclShipping}
        styling={storeIsFeatured ? 'primary' : 'lighten'}
        campaignStyling={campaignStyling}
        medium
      />
      <S.HideOnMobile>
        {price.inclShipping && (
          <>
            <S.Hidden> (</S.Hidden>
            <ShippingLabel
              toneDown
              exclShipping={price.exclShipping}
              inclShipping={price.inclShipping}
            />
            <S.Hidden>)</S.Hidden>
          </>
        )}
        {price.inclShipping && isInternationalPrice && (
          <InternationalPriceLabel
            currency={price.originalCurrency}
            value={price.originalCurrencyExclShipping}
            toneDown={!storeIsFeatured}
          />
        )}
      </S.HideOnMobile>
    </S.PriceColumn>
  ),
  (prevProps, nextProps) => {
    const { price: prevPrice, ...prevRest } = prevProps;
    const { price: nextPrice, ...nextRest } = nextProps;
    return (
      shallowEqual(prevPrice, nextPrice) && shallowEqual(prevRest, nextRest)
    );
  }
);

const { shape, string, number, bool, oneOf } = PropTypes;

PriceColumn.propTypes = {
  price: shape({
    inclShipping: number,
    exclShipping: number,
    originalCurrency: string,
    originalCurrencyExclShipping: string,
  }).isRequired,
  storeIsFeatured: bool,
  isInternationalPrice: bool,
  campaignStyling: bool,
  align: oneOf(['left', 'right']),
};

PriceColumn.defaultProps = {
  storeIsFeatured: false,
  isInternationalPrice: false,
  campaignStyling: null,
  align: 'left',
};

export default PriceColumn;
